import { FontRole } from 'types'

export const TEXT_PROPS = {
  fontWeight: 'normal',
  fontStyle: 'normal',
  padding: '0px',
}

export const MIN_FONT_SIZE = 4

export const FONT_WEIGHTS = {
  100: 'Thin',
  200: 'Extra Light',
  300: 'Light',
  400: 'Regular',
  500: 'Medium',
  600: 'Semi Bold',
  700: 'Bold',
  800: 'Extra Bold',
  900: 'Black',
}

export const FONT_ROLES_LABELS: { [F in FontRole]: string } = {
  title: 'Title',
  subtitle: 'Subtitle',
  body: 'Body',
}
